module.exports = __webpack_public_path__ + "static/feelingoLoader-f26980dffae28cc66717cde70273764d.gif";